import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  Paper,
  Typography,
} from "@material-ui/core";
import Button from "../../components/CustomButtons/Button";
const styles = {
  card: {
    border: "1px solid #E5E7EB",
    borderRadius: 12,
    padding: 24,
    marginBottom: 24,
    boxShadow: "none",
  },
  title: {
    fontSize: 22,
    fontWeight: 600,
    color: "#1E3A5F",
    marginBottom: 24,
  },
  documentCard: {
    border: "1px solid #E5E7EB",
    borderRadius: 10,
    padding: 18,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#FAFBFC",
  },
  docTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: "#1F2937",
  },
  docSubTitle: {
    fontSize: 13,
    color: "#6B7280",
    marginTop: 4,
  },
  previewContainer: {
    marginTop: 24,
    border: "1px solid #E5E7EB",
    borderRadius: 10,
    overflow: "hidden",
  },
};

const DocumentReview = ({ classes, documentDetails }) => {
  const [preview, setPreview] = useState("");

  return (
    <Paper style={styles.card}>
      <Typography style={styles.title}>
        Document Details
      </Typography>

      <Paper elevation={0} style={styles.documentCard}>
        <div>
          <Typography style={styles.docTitle}>
            Sanction Letter
          </Typography>

          <Typography style={styles.docSubTitle}>
            PDF Document
          </Typography>
        </div>

        <Button
          size="small"
          className={classes.nextButton}
          onClick={() => setPreview(documentDetails?.sanctionletter)}
        >
          Preview
        </Button>
      </Paper>

      {preview && (
        <div style={styles.previewContainer}>
          <iframe
            title="Sanction Letter"
            src={`${preview}`}
            width="100%"
            height="650px"
            frameBorder="0"
          />
        </div>
      )}
    </Paper>
  );
};

DocumentReview.propTypes = {
  classes: PropTypes.object,
  documentDetails: PropTypes.object,
};

export default DocumentReview;